import * as React from "react";
import Component from "../../AbstractComponent";
import CircularProgress from '@material-ui/core/CircularProgress';

export class PageTransition extends Component {
  public state = {
    display: false
  };

  constructor(public props) {
    super(props);
	}
	
	public componentWillMount() {
		this.setState({
			display: this.props.isSaving
		})
	}

	public componentWillReceiveProps(nextProps) {
		this.setState({
			display: nextProps.isSaving
		})
	}

  public render() {
		const styles = {
			display: !this.state.display ? "none" : "flex"
		};

		return (
			<div className="page-transition-component" style={styles}>
				<CircularProgress />
      </div>
		);
	}
}
